module.exports = __webpack_public_path__ + "static/media/loading.40dee793.svg";